import { useEffect } from 'react'

import { form } from '../formState'

export function useUpdatePhoneRelatedFields() {
  const formApi = form.useFormApi()

  const phoneNumberField = form.useFormField('companyPhone')
  const phoneNumberFieldValue = phoneNumberField.field.value

  useEffect(() => {
    const empty = isPhoneNumberEmpty(phoneNumberFieldValue)
    formApi.setFieldDisabledState('showContactPhone', empty)
  }, [phoneNumberFieldValue, formApi])
}

function isPhoneNumberEmpty(email: string) {
  return email.trim().length === 0
}
